import { bonusService } from '@/services'
import { SHARED_LOADING, SHARED_UNLOADING } from '@/store/shared.module'
import { locale } from '@/util'

//define module name
const MODULE_NAME = 'bonus/'
//define actions name
const A_CATEGORIES = 'getCategories'
const A_ANON_LIST = 'getAnonBonusList'
const A_MANUAL_BONUS_LIST = 'getManualBonusList'
const A_LIST = 'getMemberAvailableBonusList'
const A_HISTORY = 'getBonusHistory'
const A_GET_GRAB_COIN_DETAILS = 'getGrabCoinDetails'
const A_GRAB_COIN_NOW = 'grabCoinNow'
const A_RESET_GRAB_COIN_NOW = 'resetGrabCoinNow'
const A_GET_REWARD_COIN_LOGS = 'getRewardCoinLogs'
const A_GET_VIP_REWARDS = 'getVipRewards'
const A_GET_REBATE_HISTORY = 'getRebateHistory'
const A_CLAIM_REBATE = 'claimRebate'
const A_GET_IPL_VIP_REWARDS = 'getIPLVIPRewards'
const A_REBATE_SUMMARY_HISTORY = 'getRebateSummaryHistory'
const A_REBATE_SUMMARY_DETAIL = 'getRebateSummaryDetail'
const A_RESET_CLAIM_REBATE = 'resetClaimRebate'

//define dispatch action
export const REBATE_SUMMARY_HISTORY = MODULE_NAME + A_REBATE_SUMMARY_HISTORY
export const REBATE_SUMMARY_DETAIL = MODULE_NAME + A_REBATE_SUMMARY_DETAIL
export const RESET_CLAIM_REBATE = MODULE_NAME + A_RESET_CLAIM_REBATE
export const BONUS_CATEGORIES = MODULE_NAME + A_CATEGORIES
export const BONUS_ANON_LIST = MODULE_NAME + A_ANON_LIST
export const BONUS_MANUAL_BONUS_LIST = MODULE_NAME + A_MANUAL_BONUS_LIST
export const BONUS_LIST = MODULE_NAME + A_LIST
export const BONUS_HISTORY = MODULE_NAME + A_HISTORY
export const GRAB_COIN_NOW = MODULE_NAME + A_GRAB_COIN_NOW
export const RESET_GRAB_COIN = MODULE_NAME + A_RESET_GRAB_COIN_NOW
export const GRAB_COIN_SETTING = MODULE_NAME + A_GET_GRAB_COIN_DETAILS
export const REWARD_COIN_LOGS = MODULE_NAME + A_GET_REWARD_COIN_LOGS
export const VIP_REWARDS_SUMMARY = MODULE_NAME + A_GET_VIP_REWARDS
export const REBATE_HISTORY = MODULE_NAME + A_GET_REBATE_HISTORY
export const CLAIM_REBATE = MODULE_NAME + A_CLAIM_REBATE
export const IPL_VIP_REWARDS_SUMMARY = MODULE_NAME + A_GET_IPL_VIP_REWARDS

//define mutations name
const M_RESET_CLAIM_REBATE_RESULT = 'resetRebateResult'
const M_REBATE_SUMMARY_HISTORY = 'setRebateSummaryHistoryList'
const M_REBATE_SUMMARY_DETAIL = 'setRebateSummaryHistoryDetail'
const M_CATEGORIES = 'setCategories'
const M_ANON_LIST = 'setAnonBonusList'
const M_MANUAL_BONUS_LIST = 'setManualBonusList'
const M_LIST = 'setMemberAvailableBonusList'
const M_HISTORY = 'setBonusHistory'
const M_SET_GRAB_COIN_SETTING = 'setGrabCoinSetting'
const M_SET_REWARD_COIN_LOGS = 'setRewardCoinLogs'
const M_SET_GRAB_COIN_NOW = 'setGrabCoinNow'
const M_RESET_GRAB_COIN_NOW = 'resetGrabCoinNow'
const M_SET_VIP_REWARDS = 'setVipRewards'
const M_SET_REBATE_HISTORY = 'setRebateHistory'
const M_SET_CLAIM_REBATE_RESULT = 'setRebateResult'
const M_SET_IPL_VIP_REWARDS = 'setIPLVIPRewards'

const A_BONUS_OVERALL_STATUS = 'getBonusOverallStatus'
const A_CLAIM_BONUS = 'claimBonus'
const A_RESET_CLAIM_BONUS_STORE = 'resetClaimBonusStore'
const A_APPLY_BONUS = 'applyBonus'
const A_RESET_APPLY_BONUS_RESPONSE_STORE = 'resetApplyBonusResponseStore'
const A_APPLY_VOUCHER_CHECK = 'checkVoucherCode'
const A_APPLY_VOUCHER_CHECK_RESET = 'checkVoucherCodeReset'
const A_APPLY_VOUCHER_BONUS = 'applyVoucherCode'
const A_APPLY_VOUCHER_RESET = 'applyVoucherCodeReset'
const A_CHECK_VIP_BONUS = 'checkVipBonusAvailable'
const A_APPLY_VIP_BONUS = 'applyVipBonusAvailable'
const A_RESET_VIP_BONUS = 'resetVipBonusAvailable'
const A_VIP_CLAIM_REWARD = 'claimVipReward'
const A_VIP_CLAIM_RESET = 'resetVipClaim'
const A_IPL_VIP_REWARD = 'claimIPLVipClaim'
const A_GET_MINIMUM_DEPOSIT = 'getMinimumDeposit'
export const BONUS_MINIMUM_DEPOSIT = MODULE_NAME + A_GET_MINIMUM_DEPOSIT
export const BONUS_OVERALL_STATUS = MODULE_NAME + A_BONUS_OVERALL_STATUS
export const CLAIM_BONUS = MODULE_NAME + A_CLAIM_BONUS
export const RESET_CLAIM_BONUS_STORE = MODULE_NAME + A_RESET_CLAIM_BONUS_STORE
export const BONUS_APPLY_BONUS = MODULE_NAME + A_APPLY_BONUS
export const BONUS_RESET_APPLY_BONUS_RESPONSE_STORE = MODULE_NAME + A_RESET_APPLY_BONUS_RESPONSE_STORE
export const VOUCHER_BONUS_CHECK = MODULE_NAME + A_APPLY_VOUCHER_CHECK
export const VOUCHER_BONUS_CHECK_RESET = MODULE_NAME + A_APPLY_VOUCHER_CHECK_RESET
export const VOUCHER_BONUS_APPLY = MODULE_NAME + A_APPLY_VOUCHER_BONUS
export const VOUCHER_BONUS_APPLY_RESET = MODULE_NAME + A_APPLY_VOUCHER_RESET
export const VIP_BONUS_CHECK = MODULE_NAME + A_CHECK_VIP_BONUS
export const VIP_BONUS_APPLY = MODULE_NAME + A_APPLY_VIP_BONUS
export const VIP_BONUS_RESET = MODULE_NAME + A_RESET_VIP_BONUS
export const VIP_CLAIM_REWARD = MODULE_NAME + A_VIP_CLAIM_REWARD
export const IPL_VIP_CLAIM_REWARD = MODULE_NAME + A_IPL_VIP_REWARD
export const VIP_RESET_CLAIM = MODULE_NAME + A_VIP_CLAIM_RESET

const M_SET_MINIMUM_DEPOSIT = 'setMinimumDeposit'
const M_FAILURE = 'setFailure'
const M_OVERALL_STATUS = 'setBonusOverallStatus'
const M_CLAIM_BONUS = 'claimBonus'
const M_RESET_CLAIM_BONUS_STORE = 'resetClaimBonusStoreComplete'
const M_APPLY_BONUS = 'setApplyBonus'
const M_RESET_APPLY_BONUS_RESPONSE_STORE = 'setResetApplyBonusResponseStore'
const M_SET_VOUCHER_CHECK_RESULT = 'setCheckVoucherResult'
const M_RESET_VOUCHER_CHECK_RESULT = 'resetCheckVoucherResult'
const M_SET_VOUCHER_APPLY_RESULT = 'setApplyVoucherResult'
const M_SET_VOUCHER_APPLY_RESET = 'setApplyVoucherReset'
const M_SET_VIP_BONUS_CHECK_RESULT = 'setCheckVipBonusCheck'
const M_SET_VIP_BONUS_APPLY_RESULT = 'setApplyVipBonusCheck'
const M_SET_VIP_BONUS_RESET = 'resetVipBonus'
const M_SET_VIP_PROGRESS_CLAIM_RESULT = 'setVipProgressClaimResult'
const M_SET_IPL_VIP_PROGRESS_CLAIM_RESULT = 'setIplVipProgressClaimResult'
const M_RESET_VIP_CLAIM = 'resetVipClaim'

//init app state
const state = {
  minimumDepositValue: {
    code: 0,
    data: '',
    success: false
  },
  grabCoin: {
    complete: false,
    success: false,
    code: 0,
    error: '',
    data: 0
  },
  rewardCoinsLog: [],
  grabCoinSettings: {
    grab_name: '',
    grab_description: '',
    status: 1,
    start_date: '',
    end_date: '',
    icon_one: '',
    icon_two: '',
    title_img: '',
    home_gif: '',
    prize_probability: [],
    is_recurring_chance: 0,
    min_deposit: '',
    created_at: '',
    updated_at: ''
  },
  categories: [],
  bonusAnonList: [],
  manualBonusList: [],
  bonusList: [],
  historyList: [],

  hotBonusList: [],
  sideBonusList: [],

  overallStatusList: [],
  pagination: {
    pageNumber: 0,
    pageSize: 0,
    lastPage: 0,
    totalItems: 0
  },
  claimBonusResponse: {
    action: 'claimBonus',
    code: 0,
    success: false,
    complete: false
  },
  applyBonusResponse: {},
  errorMsg: '',
  checkVoucherResponse: {
    action: 'checkVoucher',
    complete: false,
    success: false,
    code: 0,
    data: {
      bonusIsPercentage: '',
      bonusIsUseFreespin: '',
      bonusFreespinRound: 0,
      bonusFreespinExpired: '',
      bonusPercentage: 0,
      bonusGivenAmount: 0,
      bonusTargetRollover: 0,
      voucher_expires: '',
      deposit_needed: 0
    }
  },
  applyVoucherResponse: {
    action: 'claimVoucher',
    complete: false,
    success: false,
    code: 0
  },
  vipBonusCheckResult: {
    complete: false,
    success: false,
    data: {
      available: false,
      bonusId: 0
    }
  },
  vipBonusApplyResult: {
    complete: false,
    success: false,
    data: {
      ref_id: '',
      bonus_given_amount: ''
    }
  },
  vipProgressClaimResult: {
    complete: false,
    success: false,
    data: {
      ref_id: '',
      bonus_given_amount: ''
    }
  },
  vipRewardsSummary: [
    {
      level: 0,
      rewards: 300,
      requirements: 0
    }
  ],
  iplVIPRewardsSummary: [
    {
      level: 0,
      rewards: 300,
      requirements: 0
    }
  ],
  vipRewardsLoadResult: {
    complete: false,
    success: false
  },
  iplVipRewardsLoadResult: {
    complete: false,
    success: false
  },
  rebateHistory: {
    data: [],
    pagination: {},
    totalRebate: {},
    lastClaimed: {}
  },
  bonusHistory: {
    data: [],
    pagination: {}
  },
  claimRebateResult: {
    action: 'claimRebate',
    complete: false,
    success: false,
    code: 0
  },
  rebateSummaryHistory: {
    data: [],
    pagination: {}
  },
  rebateSummaryDetail: {
    data: [],
    total: {
      total_valid_bet_amount: {},
      total_rebate_amount: {}
    },
    period_time: {
      start_period: {},
      end_period: {}
    }
  }
}

//to retrieve data from store state (called by component)
const getters = {}

//to perform some actions related with updating state (called by component)
const actions = {
  [A_REBATE_SUMMARY_HISTORY]({ dispatch, commit }, { rebateObj }) {
    dispatch(`${SHARED_LOADING}`, {}, { root: true })
    bonusService.getRebateSummaryHistory(rebateObj).then(
      data => {
        let result = data
        dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
        commit(M_REBATE_SUMMARY_HISTORY, { result })
      },
      error => {
        let result = error
        dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
        commit(M_REBATE_SUMMARY_HISTORY, { result })
      }
    )
  },
  [A_REBATE_SUMMARY_DETAIL]({ dispatch, commit }, { rebateObj }) {
    dispatch(`${SHARED_LOADING}`, {}, { root: true })
    bonusService.getRebateSummaryDetail(rebateObj).then(
      data => {
        let result = data
        dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
        commit(M_REBATE_SUMMARY_DETAIL, { result })
      },
      error => {
        let result = error
        dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
        commit(M_REBATE_SUMMARY_DETAIL, { result })
      }
    )
  },
  [A_RESET_CLAIM_REBATE]({ commit }) {
    commit(M_RESET_CLAIM_REBATE_RESULT)
  },
  [A_GET_MINIMUM_DEPOSIT]({ dispatch, commit }) {
    dispatch(`${SHARED_LOADING}`, {}, { root: true })
    bonusService.getMinimumBonusDeposit().then(
      data => {
        let result = data
        dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
        commit(M_SET_MINIMUM_DEPOSIT, { result })
      },
      error => {
        let result = error
        dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
        commit(M_SET_MINIMUM_DEPOSIT, { result })
      }
    )
  },
  [A_GRAB_COIN_NOW]({ dispatch, commit }) {
    dispatch(`${SHARED_LOADING}`, {}, { root: true })
    bonusService.grabCoinNow().then(
      data => {
        let result = data
        dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
        commit(M_SET_GRAB_COIN_NOW, { result })
      },
      error => {
        let result = error
        dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
        commit(M_SET_GRAB_COIN_NOW, { result })
      }
    )
  },
  [A_GET_REWARD_COIN_LOGS]({ dispatch, commit }, { filter }) {
    dispatch(`${SHARED_LOADING}`, {}, { root: true })
    bonusService.getCoinsLogs(filter).then(
      data => {
        let result = data
        dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
        commit(M_SET_REWARD_COIN_LOGS, { result })
      },
      error => {
        let result = error
        dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
        commit(M_SET_REWARD_COIN_LOGS, { result })
      }
    )
  },
  [A_RESET_GRAB_COIN_NOW]({ commit }) {
    commit(M_RESET_GRAB_COIN_NOW)
  },
  [A_GET_GRAB_COIN_DETAILS]({ dispatch, commit }, { filter }) {
    dispatch(`${SHARED_LOADING}`, {}, { root: true })
    bonusService.getRewardCoins(filter).then(
      data => {
        let result = data
        dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
        commit(M_SET_GRAB_COIN_SETTING, { result })
      },
      error => {
        let result = error
        dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
        commit(M_SET_GRAB_COIN_SETTING, { result })
      }
    )
  },
  [A_CATEGORIES]({ commit }) {
    bonusService.getCategory().then(
      data => {
        let result = data
        commit(M_CATEGORIES, { result })
      },
      error => {
        let result = error
        commit(M_CATEGORIES, { result })
      }
    )
  },
  async [A_ANON_LIST]({ dispatch, commit }) {
    dispatch(`${SHARED_LOADING}`, {}, { root: true })
    await bonusService.getAnonBonusList().then(
      data => {
        let result = data
        dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
        commit(M_ANON_LIST, { result })
      },
      error => {
        let result = error
        dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
        commit(M_ANON_LIST, { result })
      }
    )
  },
  async [A_MANUAL_BONUS_LIST]({ dispatch, commit }) {
    dispatch(`${SHARED_LOADING}`, {}, { root: true })
    await bonusService.getManualBonusList().then(
      data => {
        let result = data
        dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
        commit(M_MANUAL_BONUS_LIST, { result })
      },
      error => {
        let result = error
        dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
        commit(M_MANUAL_BONUS_LIST, { result })
      }
    )
  },
  [A_LIST]({ dispatch, commit }) {
    dispatch(`${SHARED_LOADING}`, {}, { root: true })
    bonusService.getMemberAvailableBonusList().then(
      data => {
        let result = data
        dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
        commit(M_LIST, { result })
      },
      error => {
        let result = error
        dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
        commit(M_LIST, { result })
      }
    )
  },
  [A_HISTORY]({ dispatch, commit }, { bonusHistoryObj }) {
    dispatch(`${SHARED_LOADING}`, {}, { root: true })
    bonusService.getBonusHistory(bonusHistoryObj).then(
      data => {
        let result = data
        dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
        commit(M_HISTORY, { result })
      },
      error => {
        let result = error
        dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
        commit(M_HISTORY, { result })
      }
    )
  },

  [A_RESET_CLAIM_BONUS_STORE]({ commit }) {
    commit(M_RESET_CLAIM_BONUS_STORE)
  },
  [A_CLAIM_BONUS]({ dispatch, commit }, { id }) {
    dispatch(`${SHARED_LOADING}`, {}, { root: true })
    bonusService.claimBonus(id).then(
      data => {
        let result = data
        dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
        commit(M_CLAIM_BONUS, { result })
      },
      error => {
        dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
        commit(M_FAILURE, error)
      }
    )
  },
  [A_BONUS_OVERALL_STATUS]({ dispatch, commit }) {
    dispatch(`${SHARED_LOADING}`, {}, { root: true })
    bonusService.getOverallBonusStatus().then(
      data => {
        dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
        commit(M_OVERALL_STATUS, data)
      },
      error => {
        dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
        commit(M_FAILURE, error)
      }
    )
  },

  [A_APPLY_BONUS]({ dispatch, commit }, { applyBonusObj }) {
    dispatch(`${SHARED_LOADING}`, {}, { root: true })
    bonusService.applyBonus(applyBonusObj).then(
      data => {
        let result = data
        dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
        commit(M_APPLY_BONUS, { result })
      },
      error => {
        let result = error
        dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
        commit(M_APPLY_BONUS, { result })
      }
    )
  },
  [A_RESET_APPLY_BONUS_RESPONSE_STORE]({ commit }) {
    commit(M_RESET_APPLY_BONUS_RESPONSE_STORE)
  },
  [A_APPLY_VOUCHER_CHECK]({ dispatch, commit }, { voucherObj }) {
    dispatch(`${SHARED_LOADING}`, {}, { root: true })
    bonusService.checkVoucherBonus(voucherObj).then(
      data => {
        let result = data
        dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
        commit(M_SET_VOUCHER_CHECK_RESULT, { result })
      },
      error => {
        let result = error
        dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
        commit(M_SET_VOUCHER_CHECK_RESULT, { result })
      }
    )
  },
  [A_APPLY_VOUCHER_BONUS]({ dispatch, commit }, { voucherObj }) {
    dispatch(`${SHARED_LOADING}`, {}, { root: true })
    bonusService.applyVoucherBonus(voucherObj).then(
      data => {
        let result = data
        dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
        commit(M_SET_VOUCHER_APPLY_RESULT, { result })
      },
      error => {
        let result = error
        dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
        commit(M_SET_VOUCHER_APPLY_RESULT, { result })
      }
    )
  },
  [A_APPLY_VOUCHER_RESET]({ commit }) {
    commit(M_SET_VOUCHER_APPLY_RESET)
  },
  [A_CHECK_VIP_BONUS]({ dispatch, commit }) {
    dispatch(`${SHARED_LOADING}`, {}, { root: true })
    bonusService.checkVipBonus().then(
      data => {
        let result = data
        dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
        commit(M_SET_VIP_BONUS_CHECK_RESULT, { result })
      },
      error => {
        let result = error
        dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
        commit(M_SET_VIP_BONUS_CHECK_RESULT, { result })
      }
    )
  },
  [A_VIP_CLAIM_REWARD]({ dispatch, commit }) {
    dispatch(`${SHARED_LOADING}`, {}, { root: true })
    bonusService.claimProgressReward().then(
      data => {
        let result = data
        dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
        commit(M_SET_VIP_PROGRESS_CLAIM_RESULT, { result })
      },
      error => {
        let result = error
        dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
        commit(M_SET_VIP_PROGRESS_CLAIM_RESULT, { result })
      }
    )
  },
  [A_IPL_VIP_REWARD]({ dispatch, commit }) {
    dispatch(`${SHARED_LOADING}`, {}, { root: true })
    bonusService.claimIPLProgressReward().then(
      data => {
        let result = data
        dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
        commit(M_SET_IPL_VIP_PROGRESS_CLAIM_RESULT, { result })
      },
      error => {
        let result = error
        dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
        commit(M_SET_IPL_VIP_PROGRESS_CLAIM_RESULT, { result })
      }
    )
  },
  [A_VIP_CLAIM_RESET]({ dispatch, commit }) {
    commit(M_RESET_VIP_CLAIM)
  },
  [A_APPLY_VIP_BONUS]({ dispatch, commit }) {
    dispatch(`${SHARED_LOADING}`, {}, { root: true })
    bonusService.applyVipBonus().then(
      data => {
        let result = data
        dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
        commit(M_SET_VIP_BONUS_APPLY_RESULT, { result })
      },
      error => {
        let result = error
        dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
        commit(M_SET_VIP_BONUS_APPLY_RESULT, { result })
      }
    )
  },
  [A_RESET_VIP_BONUS]({ commit }) {
    commit(M_SET_VIP_BONUS_RESET)
  },
  [A_APPLY_VOUCHER_CHECK_RESET]({ commit }) {
    commit(M_RESET_VOUCHER_CHECK_RESULT)
  },
  [A_GET_VIP_REWARDS]({ commit, dispatch }) {
    dispatch(`${SHARED_LOADING}`, {}, { root: true })
    bonusService.getVipSummary().then(
      data => {
        let result = data
        dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
        commit(M_SET_VIP_REWARDS, { result })
      },
      error => {
        let result = data
        dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
        commit(M_SET_VIP_REWARDS, { result })
      }
    )
  },
  [A_GET_IPL_VIP_REWARDS]({ commit, dispatch }) {
    dispatch(`${SHARED_LOADING}`, {}, { root: true })
    bonusService.getIPLVipSummary().then(
      data => {
        let result = data
        dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
        commit(M_SET_IPL_VIP_REWARDS, { result })
      },
      error => {
        let result = data
        dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
        commit(M_SET_IPL_VIP_REWARDS, { result })
      }
    )
  },
  [A_GET_REBATE_HISTORY]({ dispatch, commit }, { obj }) {
    dispatch(`${SHARED_LOADING}`, {}, { root: true })
    bonusService.getRebateHistory(obj).then(
      data => {
        let result = data
        dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
        commit(M_SET_REBATE_HISTORY, { result })
      },
      error => {
        let result = error
        dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
        commit(M_SET_REBATE_HISTORY, { result })
      }
    )
  },
  [A_CLAIM_REBATE]({ dispatch, commit }, payload) {
    dispatch(`${SHARED_LOADING}`, {}, { root: true })
    // payload may be undefined for non-Bhaggo brands; obj carries { startTime, endTime }
    const obj = (payload && payload.obj) || {}
    bonusService.claimRebate(obj).then(
      data => {
        let result = data
        dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
        commit(M_SET_CLAIM_REBATE_RESULT, { result })
      },
      error => {
        let result = error
        dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
        commit(M_SET_CLAIM_REBATE_RESULT, { result })
      }
    )
  }
}

//to update state values (called by actions)
const mutations = {
  [M_REBATE_SUMMARY_HISTORY](state, { result }) {
    if (result.success) {
      state.rebateSummaryHistory.data = result.data
      state.rebateSummaryHistory.pagination = result.pagination
    } else {
      state.rebateSummaryHistory.data = []
      state.rebateSummaryHistory.pagination = {}
    }
  },
  [M_REBATE_SUMMARY_DETAIL](state, { result }) {
    if (result.success) {
      state.rebateSummaryDetail.data = result.data
      state.rebateSummaryDetail.total.total_valid_bet_amount = result.total.total_valid_bet_amount
      state.rebateSummaryDetail.total.total_rebate_amount = result.total.total_rebate_amount
      state.rebateSummaryDetail.period_time.start_period = result.period_time.start_period
      state.rebateSummaryDetail.period_time.end_period = result.period_time.end_period
    } else {
      state.rebateSummaryDetail.data = []
      state.rebateSummaryDetail.total.total_valid_bet_amount = {}
      state.rebateSummaryDetail.total.total_rebate_amount = {}
      state.rebateSummaryDetail.period_time.start_period = {}
      state.rebateSummaryDetail.period_time.end_period = {}
    }
  },
  [M_SET_MINIMUM_DEPOSIT](state, { result }) {
    state.minimumDepositValue = {
      code: result.code,
      data: result.data,
      success: result.success
    }
  },
  [M_SET_GRAB_COIN_NOW](state, { result }) {
    state.grabCoin = {
      complete: true,
      success: result.success,
      code: result.code,
      error: !result.success ? result.error : '',
      data: result.success ? result.data : 0
    }
  },
  [M_RESET_GRAB_COIN_NOW](state) {
    state.grabCoin = {
      complete: false,
      success: false,
      code: 0,
      error: '',
      data: 0
    }
  },
  [M_SET_REWARD_COIN_LOGS](state, { result }) {
    state.rewardCoinsLog = result.data
  },
  [M_SET_GRAB_COIN_SETTING](state, { result }) {
    let d = result.data
    if (d != null) {
      state.grabCoinSettings = {
        grab_name: d.grab_name,
        grab_description: d.grab_description,
        status: d.status,
        start_date: d.start_date,
        end_date: d.end_date,
        icon_one: d.icon_one,
        icon_two: d.icon_two,
        title_img: d.title_img,
        home_gif: d.home_gif,
        min_deposit: d.min_deposit,
        created_at: d.created_at,
        updated_at: d.updated_at
      }
    }
  },
  [M_CATEGORIES](state, { result }) {
    let p = []
    if (result.success) {
      p = result.data
    }
    state.categories = p
  },
  [M_ANON_LIST](state, { result }) {
    let p = []
    if (result.success) {
      let d = result.data
      state.bonusAnonList = []

      //process BonusList

      d.forEach(bonus => {
        let bonusLocale = []

        bonus.localization.forEach(language => {
          for (let i = 0; i < Object.keys(language).length; i++) {
            try {
              bonusLocale.push({
                language: Object.keys(language)[i],
                title: Object.values(language)[i],
                desc: bonus.desc_localization.length > 0 ? Object.values(bonus.desc_localization[0])[i] : ''
              })
            } catch (e) {
              bonusLocale.push({
                language: Object.keys(language)[i],
                title: Object.values(language)[i],
                desc: ''
              })
            }
          }
        })

        p.push({
          id: bonus.id,
          name: bonus.name,
          description: bonus.description,
          locale: bonusLocale,
          mode: bonus.bonus_mode,
          currency: bonus.currency,
          isPin: bonus.is_pinable,
          startDate: bonus.start_time,
          endDate: bonus.end_time,
          categories: bonus.categories,
          providers: bonus.providers,
          memberGroup: bonus.member_group,
          bonusMaxCap: bonus.max_cap_amount
        })
      })
    }
    state.bonusAnonList = p
  },
  [M_MANUAL_BONUS_LIST](state, { result }) {
    let p = []
    if (result.length > 0) {
      let d = result
      state.manualBonusList = []

      //process BonusList
      d.forEach(bonus => {
        if (new Date(bonus.endDate) >= new Date()) {
          p.push({
            id: bonus.id,
            name: bonus.name,
            description: bonus.description,
            locale: bonus.locale,
            mode: bonus.mode,
            currency: bonus.currency,
            isPin: bonus.isPin,
            startDate: bonus.startDate,
            endDate: bonus.endDate,
            categories: bonus.categories,
            providers: bonus.providers,
            memberGroup: bonus.member_group,
            bonusMaxCap: bonus.maximum_amount
          })
        }
      })
    }
    state.manualBonusList = p
  },
  [M_LIST](state, { result }) {
    let p = []
    if (result.success) {
      let d = result.data

      //process BonusList

      d.forEach(bonus => {
        let bonusLocale = []

        bonus.localization.forEach(language => {
          for (let i = 0; i < Object.keys(language).length; i++) {
            try {
              bonusLocale.push({
                language: Object.keys(language)[i],
                title: Object.values(language)[i],
                desc: bonus.desc_localization.length > 0 ? Object.values(bonus.desc_localization[0])[i] : ''
              })
            } catch (e) {
              bonusLocale.push({
                language: Object.keys(language)[i],
                title: Object.values(language)[i],
                desc: ''
              })
            }
          }
        })

        p.push({
          id: bonus.id,
          value: bonus.id,
          name: bonus.name,
          description: bonus.description,
          locale: bonusLocale,
          mode: bonus.bonus_mode,
          currency: bonus.currency,
          isPin: bonus.is_pinable,
          startDate: bonus.start_time,
          endDate: bonus.end_time,
          categories: bonus.categories.length > 0 ? bonus.categories : ['SPECIAL'],
          providers: bonus.providers,
          memberGroup: bonus.member_group,
          bonusMaxCap: bonus.max_cap_amount,
          maxAmount: bonus.maximum_amount,
          formula: bonus.formula,
          useReleaseTiers: bonus.use_release_tiers,
          useFreespinRelease: bonus.use_freespin_release,
          freespinReleaseRound: bonus.freespin_release_round,
          freespinReleaseBetValue: bonus.freespin_release_bet_value,
          freespinReleaseMaxRound: bonus.freespin_release_max_round,
          freespinReleaseBonusType: bonus.freespin_release_bonus_type,
          freespinReleasePercentage: bonus.freespin_release_percentage,
          freespinReleaseProvider: bonus.freespin_release_provider,
          freespinReleaseGameName: bonus.freespin_release_game_name,
          percentGive: bonus.percent_give,
          amountGive: bonus.amount_give,
          turnoverMultiplier: bonus.turnover_multiplier,
          depositAmount: bonus.deposit_amount
        })
      })
    }

    state.bonusList = p
  },
  /*[M_HISTORY](state, {result}) {
        let p = []
        if (result.success) {
            let d = result.data

            state.pagination = {
                pageNumber: result.pagination.current_page,
                pageSize: Number(result.pagination.per_page),
                lastPage: result.pagination.last_page,
                totalItems: result.pagination.total
            }

            d.forEach(bonus => {
                let bonusLocale = []

                bonus.bonus.localization.forEach(language => {
                    for (let i = 0; i < Object.keys(language).length; i++) {
                        try {
                            bonusLocale.push({
                                language: Object.keys(language)[i],
                                title: Object.values(language)[i],
                                desc: bonus.desc_localization.length > 0 ? Object.values(bonus.desc_localization[0])[i] : ''
                            })
                        } catch (e) {
                            bonusLocale.push({
                                language: Object.keys(language)[i],
                                title: Object.values(language)[i],
                                desc: ''
                            })
                        }
                    }
                })

                let bonusTotalProgress = 0

                bonus.bonus_progress.forEach(progress => {
                    bonusTotalProgress += progress.current_progress / progress.total_progress
                })

                bonusTotalProgress = bonusTotalProgress / bonus.bonus_progress.length

                p.push({
                    id: bonus.bonus.id,
                    applicantId: bonus.id,
                    value: bonus.bonus.id,
                    name: bonus.bonus.name,
                    description: bonus.description,
                    locale: bonusLocale,
                    mode: bonus.bonus.bonus_mode,
                    currency: bonus.bonus.currency,
                    isPin: bonus.bonus.is_pinable,
                    startDate: bonus.bonus.start_time,
                    endDate: bonus.bonus.end_time,
                    categories: bonus.bonus.categories.length > 0 ? bonus.categories : ['SPECIAL'],
                    providers: bonus.bonus.providers,
                    memberGroup: bonus.bonus.member_group,
                    bonusMaxCap: bonus.bonus.max_cap_amount,
                    bonusGivenAmount: bonus.bonus_given_amount,
                    bonusProgress: bonus.bonus_progress,
                    bonusTotalProgress: bonusTotalProgress,
                    bonusApplyDate: bonus.created_at,
                    bonusExpireDate: bonus.serving_expired_date,
                    refId: bonus.ref_id,
                    status: bonus.status

                })
            })
        }
        state.historyList = p
    },*/

  [M_RESET_CLAIM_BONUS_STORE](state) {
    state.claimBonusResponse = {
      action: 'claimBonus',
      complete: false,
      success: false,
      code: 0
    }
  },
  [M_CLAIM_BONUS](state, { result }) {
    state.claimBonusResponse = {
      action: 'claimBonus',
      complete: true,
      success: result.success,
      code: result.code
    }
  },
  [M_OVERALL_STATUS](state, data) {
    let d = data.data
    let processedList = []
    for (let i = 0; i < d.length; i++) {
      processedList.push(locale.getMessage(`enumBonusStatus.${d[i]}`))
    }

    state.overallStatusList = processedList
  },

  [M_APPLY_BONUS](state, { result }) {
    if (result.success) {
      let d = result.data
      state.applyBonusResponse = {
        referenceId: d.ref_id,
        status: d.status,
        complete: true,
        success: result.success,
        code: result.code,
        error: result.message
      }
    } else {
      state.applyBonusResponse = {
        complete: true,
        success: result.success,
        code: result.code,
        error: result.message
      }
    }
  },
  [M_RESET_APPLY_BONUS_RESPONSE_STORE](state) {
    state.applyBonusResponse = {
      complete: false,
      success: false,
      code: 0,
      error: ''
    }
  },
  [M_FAILURE](state, error) {
    state.errorMsg = error
  },
  [M_SET_VOUCHER_CHECK_RESULT](state, { result }) {
    state.checkVoucherResponse.complete = true
    state.checkVoucherResponse.success = result.success
    state.checkVoucherResponse.code = result.code
    if (result.success) {
      state.checkVoucherResponse.data.bonusIsPercentage = result.data.bonus_is_percentage
      state.checkVoucherResponse.data.bonusIsUseFreespin = result.data.bonus_is_use_freespin
      state.checkVoucherResponse.data.bonusFreespinRound = result.data.bonus_freespin_round
      state.checkVoucherResponse.data.bonusFreespinExpired = result.data.bonus_freespin_expired
      state.checkVoucherResponse.data.bonusPercentage = result.data.bonus_percentage_amount
      state.checkVoucherResponse.data.bonusGivenAmount = result.data.bonus_given_amount
      state.checkVoucherResponse.data.bonusTargetRollover = result.data.bonus_target_rollover
      state.checkVoucherResponse.data.voucher_expires = result.data.voucher_expires
      state.checkVoucherResponse.data.deposit_needed = result.data.deposit_needed
    }
  },
  [M_SET_VOUCHER_APPLY_RESULT](state, { result }) {
    state.applyVoucherResponse.complete = true
    state.applyVoucherResponse.success = result.success
    state.applyVoucherResponse.code = result.code
  },
  [M_SET_VOUCHER_APPLY_RESET](state) {
    state.applyVoucherResponse.complete = false
    state.applyVoucherResponse.success = false
    state.checkVoucherResponse.complete = false
    state.checkVoucherResponse.success = false
  },
  [M_SET_VIP_BONUS_CHECK_RESULT](state, { result }) {
    state.vipBonusCheckResult.complete = true
    state.vipBonusCheckResult.success = result.success
    if (result.success) {
      state.vipBonusCheckResult.data.available = result.data.available
      state.vipBonusCheckResult.data.bonusId = result.data.bonus_id
    }
  },
  [M_SET_VIP_BONUS_APPLY_RESULT](state, { result }) {
    state.vipBonusApplyResult.complete = true
    state.vipBonusApplyResult.success = result.success
    state.vipBonusApplyResult.data.fund_in_amount = result.data.fund_in_amount
    state.vipBonusApplyResult.data.bonus_given_amount = result.data.bonus_given_amount
  },
  [M_SET_VIP_BONUS_RESET](state) {
    state.vipBonusCheckResult.complete = false
    state.vipBonusCheckResult.success = false
    state.vipBonusApplyResult.complete = false
    state.vipBonusApplyResult.success = false
  },
  [M_RESET_VOUCHER_CHECK_RESULT](state) {
    state.checkVoucherResponse.complete = false
    state.checkVoucherResponse.success = false
    state.checkVoucherResponse.code = 0
    state.checkVoucherResponse.data = {}
  },
  [M_SET_VIP_PROGRESS_CLAIM_RESULT](state, { result }) {
    state.vipProgressClaimResult.complete = true
    state.vipProgressClaimResult.success = result.success
    state.vipProgressClaimResult.code = result.code
    state.vipProgressClaimResult.data = result.data
  },
  [M_SET_IPL_VIP_PROGRESS_CLAIM_RESULT](state, { result }) {
    state.vipProgressClaimResult.complete = true
    state.vipProgressClaimResult.success = result.success
    state.vipProgressClaimResult.code = result.code
    state.vipProgressClaimResult.data = result.data
  },
  [M_RESET_VIP_CLAIM](state) {
    state.vipProgressClaimResult.complete = false
    state.vipProgressClaimResult.success = false
    state.vipProgressClaimResult.code = 0
    state.vipProgressClaimResult.data = {}
  },
  [M_SET_VIP_REWARDS](state, { result }) {
    state.vipRewardsLoadResult.complete = true
    state.vipRewardsLoadResult.success = result.success
    if (!result.success) {
      return
    }
    const returnedData = result.data
    let bhaggoPrizeList = [
      { cash: 5 },
      { coins: 30 },
      { coins: 30, cash: 300, freespins: 10 },
      { coins: 60, cash: 700, freespins: 12 },
      { coins: 100, cash: 1500, freespins: 15 },
      { coins: 150, cash: 3000, freespins: 20 },
      { coins: 200, cash: 5000, freespins: 50 },
      { coins: 300, cash: 10000, freespins: 100 }
    ]
    state.vipRewardsSummary = returnedData.map(r => {
      let resulting_reward = ''
      switch (r.reward_type) {
        case 'COINS':
          resulting_reward = r.reward_upgrade.coins
          break
        case 'BONUS':
          resulting_reward = r.reward_bonus.maximum_amount + '%'
          break
        case 'GIFT':
          resulting_reward = r.reward_gift.name
          break
      }

      // if(r.level_sequence==1){
      //     resulting_reward = '30 ' + locale.getMessage('label.coins')
      // }
      return {
        level: r.level_sequence,
        reward_type: r.reward_type,
        reward_gift: r.reward_gift,
        reward_bonus: r.reward_bonus,
        reward_upgrade: r.reward_upgrade,
        text: resulting_reward,
        requirements: r.required_deposit_amount,
        bgPrizes: bhaggoPrizeList[--r.level_sequence]
      }
    })
  },
  [M_SET_IPL_VIP_REWARDS](state, { result }) {
    state.iplVipRewardsLoadResult.complete = true
    state.iplVipRewardsLoadResult.success = result.success
    if (!result.success) {
      return
    }
    const rewards = result.data
    state.iplVIPRewardsSummary = rewards.map(r => {
      let txtReward = ''
      switch (r.reward_type) {
        case 'COINS':
          txtReward = r.reward_upgrade.coins
          break
        case 'BONUS':
          txtReward = r.reward_bonus.maximum_amount + '%'
          break
        case 'GIFT':
          txtReward = r.reward_gift.name
          break
      }
      return {
        level: r.level_sequence,
        reward_type: r.reward_type,
        reward_gift: r.reward_gift,
        reward_bonus: r.reward_bonus,
        reward_upgrade: r.reward_upgrade,
        text: txtReward,
        requirements: r.required_deposit_amount
      }
    })
  },
  [M_SET_REBATE_HISTORY](state, { result }) {
    if (result.success) {
      state.rebateHistory.data = result.data
      state.rebateHistory.pagination = result.pagination
      state.rebateHistory.totalRebate = result.total
      state.rebateHistory.lastClaimed = result.claimed
    } else {
      state.rebateHistory.data = []
      state.rebateHistory.pagination = {}
      state.rebateHistory.totalRebate = {}
      state.rebateHistory.lastClaimed = {}
    }
  },
  [M_HISTORY](state, { result }) {
    if (result.success) {
      state.bonusHistory.data = result.data
      state.bonusHistory.pagination = result.pagination
    } else {
      state.bonusHistory.data = []
      state.bonusHistory.pagination = {}
    }
  },
  [M_SET_CLAIM_REBATE_RESULT](state, { result }) {
    state.claimRebateResult.complete = true
    state.claimRebateResult.success = result.success
    state.claimRebateResult.code = result.code
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
